import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "utils/axios/axiosBaseQuery";

export const recommendationTemplatesApi = createApi({
  reducerPath: 'recommendationTemplatesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/reports",
  }),
  tagTypes: ["RecommendationTemplates"],
  endpoints: (builder) => ({
    getRecommendationTemplates: builder.query({
      query: ({ assessmentId, clientType, search = "", status, page = 1, limit = 10, sort = { column: "id", direction: "DESC" } }) => {
        return ({
          method: "PATCH",
          url: `/${clientType ? clientType : null}/assesment-recommendation/list/${assessmentId ? assessmentId : ""}`,
          data: {
            search,
            status,
            page,
            limit,
            sort,
          },
        })
      },
      transformResponse: (response) => response.data,
      providesTags: ["RecommendationTemplates"]
    }),

    createRecommendationTemplate: builder.mutation({
      query: ({ clientType, values }) => ({
        method: "POST",
        url: `/${clientType}/assesment-recommendation/create`,
        data: values
      }),
      invalidatesTags: ["RecommendationTemplates"]
    }),

    removeRecommendationTemplate: builder.mutation({
      query: ({ clientType, id }) => ({
        method: "DELETE",
        url: `/${clientType}/assesment-recommendation/remove/${id}`,
      }),
      invalidatesTags: ["RecommendationTemplates"]
    }),

    createStrategyTemplate: builder.mutation({
      query: ({ clientType, values }) => ({
        method: "POST",
        url: `/${clientType}/assesment-strategy-template/create`,
        data: values
      }),
      invalidatesTags: ["StrategyTemplates"]
    }),

    updateRecommendationsTemplate: builder.mutation({
      query: ({ clientType, values, id }) => ({
        method: "PATCH",
        url: `/${clientType}/assesment-recommendation/update/${id}`,
        data: values
      }),
      invalidatesTags: ["RecommendationTemplates"]
    }),

    updateStrategyTemplate: builder.mutation({
      query: ({ clientType, values, id }) => ({
        method: "PATCH",
        url: `/${clientType}/assesment-strategy-template/update/${id}`,
        data: values
      }),
      invalidatesTags: ["StrategyTemplates"]
    }),

    getStartegyTemplates: builder.query({
      query: ({ assessmentId, clientType, search = "", tags = [], status = "yes", page = 1, limit = 10, sort = { column: "id", direction: "DESC" } }) => {
        return ({
          method: "PATCH",
          url: `/${clientType}/assesment-strategy-template/list/${assessmentId ? assessmentId : ""}`,
          data: {
            search,
            status,
            page,
            limit,
            sort,
            tags: tags || []
          },
        })
      },
      transformResponse: (response) => response.data,
      providesTags: ["StrategyTemplates"]
    }),

    removeStrategyTemplate: builder.mutation({
      query: ({ clientType, id }) => ({
        method: "DELETE",
        url: `/${clientType}/assesment-strategy-template/remove/${id}`,
      }),
      invalidatesTags: ["StrategyTemplates"]
    }),

  })
})

export const {
  useCreateRecommendationTemplateMutation,
  useGetRecommendationTemplatesQuery,
  useLazyGetRecommendationTemplatesQuery,
  useRemoveRecommendationTemplateMutation,
  useCreateStrategyTemplateMutation,
  useLazyGetStartegyTemplatesQuery,
  useGetStartegyTemplatesQuery,
  useRemoveStrategyTemplateMutation,
  useUpdateStrategyTemplateMutation,
  useUpdateRecommendationsTemplateMutation
} = recommendationTemplatesApi;